const baseUrlDev = 'http://totaluk.energysalesdirect.com';
const baseUrlProd = 'https://totalenergies.energymarketprice.com';

const rootApiUrlDev = 'http://totaluk.energysalesdirect.com/api';
const rootApiUrlProd = 'https://totalenergies.energymarketprice.com/api';

const apiUrlDev = 'http://totaluk.energysalesdirect.com/api/Energy';
const apiUrlProd = 'https://totalenergies.energymarketprice.com/api/Energy';

export const BASE_URL = process.env.REACT_APP_ENV === 'prod' ? baseUrlProd : baseUrlDev;
export const ROOT_API_URL = process.env.REACT_APP_ENV === 'prod' ? rootApiUrlProd : rootApiUrlDev;
export const API_URL = process.env.REACT_APP_ENV === 'prod' ? apiUrlProd : apiUrlDev;

let BUILD_PREFIX = '';

if (process.env.REACT_APP_ENV === 'prod') {
  BUILD_PREFIX = '/daily';
} else if (process.env.REACT_APP_ENV === 'dev') {
  BUILD_PREFIX = '/daily-dev';
}

export const PATH_PREFIX = BUILD_PREFIX;
